module.exports = __webpack_public_path__ + "img/mainSlope-nav.023f406c.svg";